<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="box-content-picker-header">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" id="box-content-picker-header">Select files</h4>
        </div>
        <div v-if="shown" class="modal-body mb-0 p-0">
          <iframe :src="iframeUrl"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2';

export default {
  name: 'box-content-picker-modal',
  props: {
    id: {
      type: String,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    iframeId() {
      return btoa(this.id);
    },
    iframeUrl() {
      return `/integration/box/content-picker?id=${this.iframeId}`;
    },
  },
  watch: {
    shown: {
      immediate: true,
      handler(shown) {
        $(`#${this.id}`).modal(shown ? 'show' : 'hide');
      },
    },
  },
  methods: {
    hideModal() {
      this.$emit('hide');
    },
    onMessage(event) {
      const {type, id, items} = event.data;
      if (type === 'box-content-picker-cancel' && id === this.iframeId) {
        this.hideModal();
      } else if (type === 'box-content-picker-choose' && id === this.iframeId) {
        this.processSelectedItems(items);
      }
    },
    processSelectedItems(items) {
      const publicItems = (items || []).filter(
        item => item.shared_link && item.shared_link.effective_access === 'open'
      );

      if (publicItems.length < items.length) {
        this.showSelectionWarning();
      } else {
        const files = publicItems.map(({name, shared_link}) => ({name, url: shared_link.url}));
        this.$emit('select-files', files);
        this.hideModal();
      }
    },
    showSelectionWarning() {
      swal.fire({
        title: 'Wrong access rights detected!',
        text: `You have selected some files that are not publicly accessible. Make sure you set 'Access: People with the link' for each file you want to share.`,
        type: 'warning',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary',
      });
    },
  },
  mounted() {
    window.addEventListener('message', event => this.onMessage(event));
    $(`#${this.id}`).on('hidden.bs.modal', () => this.$emit('hide'));
  },
};
</script>

<style lang="scss" scoped>
.modal {
  background-color: rgba(#000, 0.5);
}

.close {
  top: 14px;
  right: 20px;
}

.modal-loading-indicator {
  background: center / 50px no-repeat url('/wp-content/themes/snappy-theme/assets/images/loading2.gif');
  height: 50px;
  width: 50px;
  margin: 0 auto;
}

button:hover {
  background-color: unset;
}

iframe {
  border: 0;
  height: 80vh;
  width: 100%;
}
</style>
